function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.54 8.81a2.96 2.96 0 100-5.92 2.96 2.96 0 000 5.92zm-11.08 0a2.96 2.96 0 100-5.92 2.96 2.96 0 000 5.92zm11.08 12.3a2.96 2.96 0 100-5.92 2.96 2.96 0 000 5.92zm-11.08 0a2.96 2.96 0 100-5.92 2.96 2.96 0 000 5.92z"
})));